import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {isEqual} from "lodash";
import {makeAutoObservable} from "mobx";

export interface IPredictModalController extends ViewController {
	get i18n(): ILocalizationStore;
	get isVisible(): boolean;

	close: () => void;
}

@injectable()
export class PredictModalController implements IPredictModalController {
	constructor(
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get modal() {
		return this._modalsStore.modal;
	}

	get isVisible() {
		return isEqual(this.modal, ModalType.PREDICT);
	}

	close = () => this._modalsStore.hideModal();
}
